import { HTTP_STATUS_CODE } from '@api/api';
import LOCALES, { getCurrentLocaleMessages } from '@i18n/locales';
import {
	QueryCache,
	QueryClient,
	QueryClientProvider
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AppIntl from 'AppIntl';
import { initApp } from 'appSetup';
import { AxiosError } from 'axios';
import { IS_TEST_MODE } from 'constants/global';
import { APP_ROUTES } from 'constants/routes';
import { SessionProvider } from 'hooks/useSession';
import React from 'react';
import { IntlProvider } from 'react-intl';
import AppRouter from 'routes/AppRouter';

initApp();

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			networkMode: 'offlineFirst',
			retry: IS_TEST_MODE
				? false
				: (count, error) => {
						const axiosError = error as AxiosError;
						// only retry get requests and up to 3 retries.
						return (
							axiosError.config?.method?.toLowerCase() === 'get' && count < 3
						);
				  },
			cacheTime: IS_TEST_MODE ? Infinity : undefined,
			staleTime: !IS_TEST_MODE ? 1000 * 4 : undefined // 4 seconds
		}
	},
	queryCache: new QueryCache({
		onError: (error: any) => {
			if (error?.response?.status === HTTP_STATUS_CODE.unauthorized) {
				window.location.href = APP_ROUTES.login;
			}
		}
	})
});

const App = () => (
	<IntlProvider locale={LOCALES.en} messages={getCurrentLocaleMessages()}>
		<AppIntl />
		<SessionProvider>
			<QueryClientProvider client={queryClient}>
				<AppRouter />
				<ReactQueryDevtools />
			</QueryClientProvider>
		</SessionProvider>
	</IntlProvider>
);

export default App;
